import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { pains } from '../data/copy';
export function ProblemSection() {
  return <section className="defer-paint w-full bg-surface py-12 sm:py-14" aria-labelledby="problem-heading" data-id="element-159" data-mp="2lqgwkp38r9v5">
      <div className="mx-auto max-w-5xl px-6" data-id="element-160" data-mp="2vqhimishw431">
        <SectionHeading eyebrow="Il problema reale" title={<span id="problem-heading" data-id="element-162" data-mp="39hvy4fn71n5c">Ti riconosci?</span>} data-id="element-161" data-mp="2vpplh3j91yan" />

        <div className="mx-auto mt-9 max-w-3xl space-y-5 border-l-2 border-accent/40 pl-6 sm:pl-8" data-id="element-163" data-mp="39gb5wwocqgan">
          <p className="font-serif text-2xl font-bold leading-snug text-ink sm:text-[1.75rem]" data-id="element-164" data-mp="35frbw1z2rssq">
            Domenica sera. Le 21:00. Domani mattina hai una classe di yoga.
          </p>
          <p className="font-sans text-[0.95rem] leading-relaxed text-muted" data-id="element-165" data-mp="3eia8438cv760">
            E stai ancora lì a cercare sequenze online, sfogliando libri,
            cercando di costruire qualcosa che scorra, che sia professionale,
            che non sembri improvvisato.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-x-8 gap-y-5 sm:grid-cols-2" data-id="element-166" data-mp="jeeomg1zv5eu">
          {pains.map(pain => <li key={pain} className="flex gap-3" data-id="element-167" data-mp="ocq00v7xtnz6">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-line bg-card" aria-hidden="true" data-id="element-168" data-mp="se1rz7eaalaj">
                <XIcon className="h-3 w-3 text-accent" strokeWidth={3} data-id="element-169" data-mp="x62zkg0ibnu8" />
              </span>
              <span className="font-sans text-[0.9rem] font-semibold leading-snug text-ink" data-id="element-170" data-mp="122tj5dbit1ke">
                {pain}
              </span>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl border-t border-line pt-8 text-center" data-id="element-171" data-mp="1c19b1iidgeuy">
          <p className="font-sans text-base leading-relaxed text-muted" data-id="element-172" data-mp="1g347o9pcy42e">
            Il problema non è che non sai insegnare yoga.
          </p>
          <p className="mt-2 font-serif text-2xl font-bold leading-snug text-ink sm:text-[1.75rem]" data-id="element-173" data-mp="3duqcu5jtmlhs">
            Il problema è che nessuno ti ha mai dato uno strumento{' '}
            <span className="text-accent" data-id="element-174" data-mp="ozh6ukkx1iqd">completo, pronto, che funziona</span>.
          </p>
        </div>
      </div>
    </section>;
}